import React from "react";
import { FiInbox } from "react-icons/fi";
import AuthInput from "../../../components/Input/AuthInput";
import CustomPagination from "../../../components/TablePagination/TablePagination";
import { getInvoicePartyName } from "../../../utils/invoice";
import ReportInvoiceCard from "./ReportInvoiceCard";

const ReportInvoiceCardList = ({
  invoices = [],
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  searchText,
  setSearchText,
  searchInvoice,
  setSearchInvoice,
  namePlaceholder = "Search customer",
  emptyMessage = "No invoices found for this date range.",
  variant = "sale",
  editable = false,
}) => {
  const filtered = invoices.filter((dt) => {
    const nameMatched =
      searchText === ""
        ? true
        : getInvoicePartyName(dt)
            .toLowerCase()
            .includes(searchText.toLowerCase());
    const invoiceQuery = searchInvoice.trim().toLowerCase();
    const invoiceMatched =
      invoiceQuery === ""
        ? true
        : String(dt.invoice_no || "")
            .toLowerCase()
            .includes(invoiceQuery) ||
          String(dt.auto_invoice_no ?? "")
            .toLowerCase()
            .includes(invoiceQuery);
    return invoiceMatched && nameMatched;
  });

  const pageRows = filtered.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  if (!invoices.length) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4 rounded-2xl border-2 border-dashed border-line bg-subtle/60">
        <div className="w-16 h-16 rounded-2xl bg-brandSoft flex items-center justify-center mb-4">
          <FiInbox className="text-main" size={28} />
        </div>
        <p className="font-bold text-ink text-lg">No invoices</p>
        <p className="text-sm text-muted mt-1 text-center max-w-xs">
          {emptyMessage}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full gap-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <AuthInput
          Value={searchText}
          setValue={setSearchText}
          placeholder={namePlaceholder}
        />
        <AuthInput
          Value={searchInvoice}
          setValue={setSearchInvoice}
          placeholder="Search invoice # or auto #"
        />
      </div>

      {filtered.length === 0 ? (
        <div className="w-full text-center text-muted py-10 text-sm rounded-xl border border-dashed border-line bg-subtle/60">
          No matches for your search.
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          {pageRows.map((invoice) => (
            <ReportInvoiceCard
              key={invoice._id || invoice.id}
              invoice={invoice}
              variant={variant}
              editable={editable}
            />
          ))}
        </div>
      )}

      <CustomPagination
        count={filtered.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        RowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </div>
  );
};

export default ReportInvoiceCardList;
